import {
  CreateUpdateWorkflowTrigger,
  WorkflowEvent,
  WorkflowTriggerConfig,
  WorkflowTriggerType,
} from "@/types/breeze/Workflow";

export const ACTION_ID_PROXY_KEY = "__action_id_proxy";

export const emptyTrigger = (): CreateUpdateWorkflowTrigger => ({
  type: WorkflowTriggerType.Event,
  enabled: true,
  config: {
    event: WorkflowEvent.None,
    event_entity: "",
    manual_entities: [],
    cron_expression: "",
    api_route: "",
  },
});

export function toTriggerFormValues(
  triggers: CreateUpdateWorkflowTrigger[] | null | undefined,
): CreateUpdateWorkflowTrigger[] {
  if (!triggers || triggers.length === 0) return [emptyTrigger()];

  return triggers.map((t) => ({
    type: t.type,
    enabled: t.enabled,
    config: {
      ...t.config,
      event: t.config?.event ?? WorkflowEvent.None,
      event_entity: t.config?.event_entity ?? "",
      manual_entities: t.config?.manual_entities ?? [],
      cron_expression: t.config?.cron_expression ?? "",
      api_route: t.config?.api_route ?? "",
    },
  }));
}

export function toTriggerRequests(
  formTriggers: CreateUpdateWorkflowTrigger[],
  originalTriggers: CreateUpdateWorkflowTrigger[] | null | undefined,
): CreateUpdateWorkflowTrigger[] {
  return formTriggers.map((t) => {
    const config: WorkflowTriggerConfig & Record<string, unknown> = {
      ...t.config,
    };
    delete config[ACTION_ID_PROXY_KEY];

    // The API only recomputes next_run_at when it's absent, so a stale one would keep the old schedule.
    const scheduleUnchanged = (originalTriggers ?? []).some(
      (o) =>
        o.config?.next_run_at === config.next_run_at &&
        o.config?.cron_expression === config.cron_expression,
    );
    if (config.next_run_at && !scheduleUnchanged) {
      delete config.next_run_at;
    }

    return { type: t.type, enabled: t.enabled, config };
  });
}
